export default "skymp5-front/b187e922b16169c34c516b8a1c737b23.png";